export default "__VITE_ASSET__884dea8a__"